import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {inject, Injectable} from "@angular/core";
import {catchError, Observable, throwError} from "rxjs";
import ErrorService from "../services/error.service";
import LoaderService from "../services/loader.service";
import {AuthService} from "../services/auth.service";

@Injectable()
export default class HttpErrorInterceptor implements HttpInterceptor {
  private readonly errorService: ErrorService = inject(ErrorService);
  private readonly authService: AuthService = inject(AuthService);
  private readonly loadingService: LoaderService = inject(LoaderService);

  public intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401) {
          this.loadingService.hide();
          this.authService.registerLogout();
          return throwError(() => error);
        }

        // for all 422 errors that only contains one error(string)
        if (error.status === 422) {
          if (typeof error?.error?.error === 'string') {
            this.errorService.show(
              error.error.error,
              error.error.message
            );
            return throwError(() => error);
          }
        }

        if (error.status === 429) {
          this.loadingService.hide();
          return throwError(() => error);
        }

        if (
          (error.status < 200 || error.status > 299)
          && error.status != 401 // not loggedin
          && error.status != 406 // new password required
          && error.status != 422 // unprocessable entity (validation error)
          && error.status != 429 // too many requests (login attempts)
        ) {
          this.loadingService.hide();

          if (error.message) {
            this.errorService.show(
              error.statusText,
              error.message
            );
            return throwError(() => error);
          }

          //as this an uncertain error, we need to check if property is actually available and readable
          //if not, we will get an error
          if (typeof error?.error?.text === 'function') {
            error?.error?.text().then((errorResponseText: string) => {
              const response: { message: string } = JSON.parse(errorResponseText)
              this.errorService.show(
                error.statusText,
                response.message
              );
            })
          }

        }
        return throwError(() => error);
      })
    );
  }
}
